<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:body>
            <b-table-simple striped bordered small>
                <b-tr>
                    <b-th style="width:30%">{{ $t('committee.committee') }}</b-th>
                    <b-td>{{ ($i18n.locale==='bn') ? meetingMinute.committee_name_bn :  meetingMinute.committee_name }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('committee.agenda') }}</b-th>
                    <b-td>{{ ($i18n.locale=='bn')? meetingMinute.agenda_name_bn :  meetingMinute.agenda_name }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('committee.decisionl') }}</b-th>
                    <b-td>{{ ($i18n.locale=='bn')? meetingMinute.decision_bn :  meetingMinute.decision }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('committee.attendance_attachment') }}</b-th>
                    <b-td>{{ ($i18n.locale=='bn')? meetingMinute.attendance_attachment :  meetingMinute.attendance_attachment }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th>{{ $t('committee.document_attachment') }}</b-th>
                    <b-td>{{ ($i18n.locale=='bn')? meetingMinute.document_attachment :  meetingMinute.document_attachment }}</b-td>
                </b-tr>
            </b-table-simple>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import RestApi, { commonServiceBaseUrl } from '@/config/api_config'
import { meetingMinuteList } from '../../api/routes'

export default {
  name: 'UiDataTable',
  props: ['id'],
  components: {
  },
  data () {
    return {
      pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: this.$store.state.commonObj.perPage,
        slOffset: 1
      },
      meetingMinute: {},
      editItemId: 0,
      rows: [],
      committeeList: [],
      downloadUrl: commonServiceBaseUrl
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    loadingState: function (newVal, oldVal) {
      if (newVal) {
        this.loadData()
      }
    }
  },
  created () {
    this.loadData()
    this.getCommitteelist()
    this.listData()
  },
  mounted () {
    core.index()
  },
  methods: {
    listData () {
      this.meetingMinute = this.$store.state.list.find(item => item.id === this.id)
    },
    testClick () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      RestApi.getData(commonServiceBaseUrl, meetingMinuteList, params).then(response => {
        if (response.success) {
          this.$store.dispatch('Committee/addMeetingMinuteList', response.data.data)
          this.paginationData(response.data)
        }
      })
      //
      this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
    },
    getCommitteelist () {
      RestApi.getData(commonServiceBaseUrl, 'committee-create/list').then(response => {
        this.committeeList = response.data.data.map((obj, index) => {
          if (this.$i18n.locale === 'bn') {
            return { value: obj.id, text: obj.committee_name_bn }
          } else {
            return { value: obj.id, text: obj.committee_name }
          }
        })
      })
    }
  }
}
</script>
